module.exports = __webpack_public_path__ + "img/Financial-Position-.cb47757f.jpg";